<template>
    <div class="mb-5 grid grid-cols-2 gap-3">
        <CFormGroup class="!mb-0" :label="startLabel">
            <CFormSelect
                allow-empty
                :disabled="disabled"
                :options="availableStartYearOptions"
                placeholder="Vybrať rok"
                :model-value="startYear"
                @update:model-value="updateStartYear(Number($event))"
            />
        </CFormGroup>

        <CFormGroup class="!mb-0" :label="endLabel">
            <CFormSelect
                allow-empty
                :disabled="!startYear || disabled"
                :options="availableEndYearOptionsWithOngoing"
                :placeholder="startYear ? '' : ''"
                :model-value="endYear || ''"
                @update:model-value="updateEndYear($event)"
            />
        </CFormGroup>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { listYearsBack } from '#shared/utils'
import CFormGroup from '@/components/ui/CFormGroup.vue'
import CFormSelect from '@/components/ui/CFormSelect.vue'

const props = defineProps({
    startLabel: {
        type: String,
        default: ''
    },
    endLabel: {
        type: String,
        default: ''
    },
    startYear: {
        type: Number,
        default: undefined
    },
    endYear: {
        type: Number,
        default: undefined
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['change'])

const availableStartYearOptions = computed((): number[] => {
    return listYearsBack()
})

const availableEndYearOptions = computed((): number[] => {
    return props.startYear ? listYearsBack(props.startYear) : []
})

const availableEndYearOptionsWithOngoing = computed(() => {
    if (!props.startYear) return []
    
    const yearOptions = listYearsBack(props.startYear)
    
    // Create options object where keys are values and values are labels
    const optionsObject: Record<string, string> = {
        '': 'Stále prebieha'
    }
    
    // Add year options
    yearOptions.forEach(year => {
        optionsObject[year.toString()] = year.toString()
    })
    
    return optionsObject
})

function updateEndYear(endYear: string | undefined) {
    emit('change', {
        endYear: !endYear ? undefined : Number(endYear)
    })
}

function updateStartYear(startYear: number) {
    if (!startYear) {
        emit('change', { startYear, endYear: undefined })
        return
    }

    if (props.endYear && !availableEndYearOptions.value.includes(props.endYear)) {
        emit('change', { startYear, endYear: undefined })
        return
    }

    emit('change', { startYear })
}
</script>